export default __webpack_public_path__ + "static/media/glitter.c61154be.jpeg";